import * as ActionTypes from '../constants/ActionTypes'
import API from '../helpers/api'

export function getBusRoutes() {
    return async dispatch => {
        dispatch({
            type: ActionTypes.GET_TRANSPORT_BUS_ROUTES_REQUEST,
            payload: {
                loading: true
            }
        })

        try {
            const response = await API.transport.getBusRoutes()

            if (response?.meta?.code !== 200) {
                dispatch({
                    type: ActionTypes.GET_TRANSPORT_BUS_ROUTES_ERROR,
                    payload: {
                        meta: response.meta,
                        loading: false
                    }
                })

                return
            }

            const { bus_routes } = response.data || {}

            dispatch({
                type: ActionTypes.GET_TRANSPORT_BUS_ROUTES_SUCCESS,
                payload: {
                    loading: false,
                    bus_routes
                }
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export function getBusRoutesEta(query) {
    return async dispatch => {
        dispatch({
            type: ActionTypes.GET_TRANSPORT_BUS_ROUTES_ETA_REQUEST,
            payload: {
                loading_bus_routes_eta: true,
                bus_stops_etas: null,
            }
        })

        try {
            const response = await API.transport.getBusRoutesEta(query)

            if (response?.meta?.code !== 200) {
                dispatch({
                    type: ActionTypes.GET_TRANSPORT_BUS_ROUTES_ETA_ERROR,
                    payload: {
                        meta: response.meta,
                        loading_bus_routes_eta: false
                    }
                })

                return
            }

            const { etas: bus_routes_etas } = response.data || {}

            dispatch({
                type: ActionTypes.GET_TRANSPORT_BUS_ROUTES_ETA_SUCCESS,
                payload: {
                    loading_bus_routes_eta: false,
                    bus_routes_etas
                }
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export function getBusStops(query) {
    return async dispatch => {
        dispatch({
            type: ActionTypes.GET_TRANSPORT_BUS_STOPS_REQUEST,
            payload: {
                loading: true
            }
        })

        try {
            const response = await API.transport.getBusStops(query)

            if (response?.meta?.code !== 200) {
                dispatch({
                    type: ActionTypes.GET_TRANSPORT_BUS_STOPS_ERROR,
                    payload: {
                        meta: response.meta,
                        loading: false
                    }
                })

                return
            }

            const { bus_stops } = response.data || {}

            dispatch({
                type: ActionTypes.GET_TRANSPORT_BUS_STOPS_SUCCESS,
                payload: {
                    loading: false,
                    bus_stops
                }
            })
        } catch (err) {
            console.error(err.message)
        }

    }
}

export function getBusStopsEta(query) {
    return async dispatch => {
        dispatch({
            type: ActionTypes.GET_TRANSPORT_BUS_STOPS_ETA_REQUEST,
            payload: {
                loading_bus_stops_eta: true,
                bus_routes_etas: null,
            }
        })

        try {
            const response = await API.transport.getBusStopsEta(query)

            if (response?.meta?.code !== 200) {
                dispatch({
                    type: ActionTypes.GET_TRANSPORT_BUS_STOPS_ETA_ERROR,
                    payload: {
                        meta: response.meta,
                        loading_bus_stops_eta: false
                    }
                })

                return
            }

            const { etas: bus_stops_etas } = response.data || {}

            dispatch({
                type: ActionTypes.GET_TRANSPORT_BUS_STOPS_ETA_SUCCESS,
                payload: {
                    loading_bus_stops_eta: false,
                    bus_stops_etas
                }
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export function getStopsByRouteAndSequence(query) {
    return async dispatch => {
        dispatch({
            type: ActionTypes.GET_TRANSPORT_BUS_ROUTE_STOPS_REQUEST,
            payload: {
                loading_bus_route_stops: true
            }
        })

        try {
            const response = await API.transport.getStopsByRouteAndSequence(query)

            if (response?.meta?.code !== 200) {
                dispatch({
                    type: ActionTypes.GET_TRANSPORT_BUS_ROUTE_STOPS_ERROR,
                    payload: {
                        meta: response.meta,
                        loading_bus_route_stops: false
                    }
                })

                // return
            }

            const { stops: bus_route_stops } = response.data || {}

            dispatch({
                type: ActionTypes.GET_TRANSPORT_BUS_ROUTE_STOPS_SUCCESS,
                payload: {
                    loading_bus_route_stops: false,
                    bus_route_stops
                }
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export function getDestinations() {
    return async dispatch => {
        dispatch({
            type: ActionTypes.GET_TRANSPORT_DESTINATIONS_REQUEST,
            payload: { loading: true }
        })

        try {
            const response = await API.transport.getDestinations()

            if (response?.meta?.code !== 200) {
                dispatch({
                    type: ActionTypes.GET_TRANSPORT_DESTINATIONS_ERROR,
                    payload: { meta: response.meta, loading: false }
                })
                return
            }

            const { destinations } = response.data || {}

            dispatch({
                type: ActionTypes.GET_TRANSPORT_DESTINATIONS_SUCCESS,
                payload: { loading: false, destinations }
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export function getLocations() {
    return async dispatch => {
        dispatch({
            type: ActionTypes.GET_TRANSPORT_LOCATIONS_REQUEST,
            payload: { loading: true }
        })

        try {
            const response = await API.transport.getLocations()

            if (response?.meta?.code !== 200) {
                dispatch({
                    type: ActionTypes.GET_TRANSPORT_LOCATIONS_ERROR,
                    payload: { meta: response.meta, loading: false }
                })
                return
            }

            const { locations } = response.data || {}

            dispatch({
                type: ActionTypes.GET_TRANSPORT_LOCATIONS_SUCCESS,
                payload: { loading: false, locations }
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export function getLocationEta(query) {
    return async dispatch => {
        dispatch({
            type: ActionTypes.GET_TRANSPORT_LOCATION_ETA_REQUEST,
            payload: {
                loading_bus_stops_eta: true,
                bus_routes_etas: null,
            }
        })

        try {
            const response = await API.transport.getLocationEta(query)

            if (response?.meta?.code !== 200) {
                dispatch({
                    type: ActionTypes.GET_TRANSPORT_LOCATION_ETA_ERROR,
                    payload: { meta: response.meta, loading_bus_stops_eta: false }
                })
                return
            }

            const { etas: bus_stops_etas } = response.data || {}

            dispatch({
                type: ActionTypes.GET_TRANSPORT_LOCATION_ETA_SUCCESS,
                payload: { loading_bus_stops_eta: false, bus_stops_etas }
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export function getShuttleSchedules() {
    return async dispatch => {
        dispatch({
            type: ActionTypes.GET_SHUTTLE_SCHEDULES_REQUEST,
            payload: { loading_shuttle_schedules: true }
        })

        try {
            const response = await API.transport.getShuttleSchedules()

            if (response?.meta?.code !== 200) {
                dispatch({
                    type: ActionTypes.GET_SHUTTLE_SCHEDULES_ERROR,
                    payload: { meta: response.meta, loading_shuttle_schedules: false }
                })
                return
            }

            const { shuttle_schedules } = response.data || {}

            dispatch({
                type: ActionTypes.GET_SHUTTLE_SCHEDULES_SUCCESS,
                payload: { loading_shuttle_schedules: false, shuttle_schedules }
            })
        } catch (err) {
            console.error(err.message)
        }
    }
}

export function resetPage() {
    return dispatch => {
        dispatch({
            type: ActionTypes.RESET_TRANSPORT_PAGE,
        })
    }
}

export function resetMeta() {
    return dispatch => {
        dispatch({
            type: ActionTypes.RESET_TRANSPORT_META,
        })
    }
}